import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { IonButton, IonSpinner } from '@ionic/vue';
    import { toRefs } from 'vue';
    import router from '@/router';

    type Color =
        | 'primary'
        | 'secondary'
        | 'tertiary'
        | 'success'
        | 'warning'
        | 'danger'
        | 'light'
        | 'medium'
        | 'dark';
    type Expand = 'block' | 'full' | 'default';
    type Size = 'small' | 'default' | 'large';
    type Shape = 'round';
    type Fill = 'solid' | 'outline' | 'clear';
    type Spinner =
        | 'dots'
        | 'lines'
        | 'lines-small'
        | 'lines-sharp'
        | 'lines-sharp-small'
        | 'bubbles'
        | 'circles'
        | 'circular'
        | 'crescent';
    type IconSlot = 'start' | 'end' | 'icon-only';

    interface Props {
        color?: Color;
        expand?: Expand;
        size?: Size;
        shape?: Shape;
        isLoading?: boolean;
        disabled?: boolean;
        spinner?: Spinner;
        fill?: Fill;
        to?: any;
        download?: boolean;
        href?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    color: { default: 'primary' },
    expand: { default: 'block' },
    size: { default: 'default' },
    shape: {},
    isLoading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    spinner: { default: 'crescent' },
    fill: { default: 'solid' },
    to: {},
    download: { type: Boolean, default: false },
    href: {}
  },
  setup(__props: any) {

    const props = __props;

    const { to } = toRefs(props);

    const redirectToRoute = () => {
        if (!to.value) return;
        router.push(to.value);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonButton), {
    color: __props.color,
    expand: __props.expand === 'default' ? undefined : __props.expand,
    size: __props.size,
    shape: __props.shape,
    disabled: __props.isLoading || __props.disabled,
    fill: __props.fill,
    href: __props.href,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (!!_unref(to) && redirectToRoute()))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      (__props.isLoading)
        ? (_openBlock(), _createBlock(_unref(IonSpinner), {
            key: 0,
            slot: "end",
            class: "ml-2 size-4",
            name: __props.spinner
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["color", "expand", "size", "shape", "disabled", "fill", "href"]))
}
}

})